import App from './routes';

export default App;
